import { createClient } from '@supabase/supabase-js';

// Cliente de la BASE CENTRAL de Corredata (proyecto Supabase "corredata-control").
// Las llaves van por variables de entorno del deploy (Cloudflare), NUNCA en el repo:
//   REACT_APP_SUPABASE_URL  -> URL del proyecto corredata-control
//   REACT_APP_SUPABASE_KEY  -> llave anon (publicable) de corredata-control
const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_KEY;

export const supabase = createClient(url || '', key || '');
export const configOk = !!(url && key);
